export default __webpack_public_path__ + "static/media/bedroom.fe350c36.webp";